import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Typography,
    Divider,
    Button,
    CircularProgress,
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import Fields from 'ui/form/FieldsForm';

const useStyles = makeStyles(theme => {
    return {
        verifyContainer: {
            marginTop: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
        },
        divider: {
            margin: `${theme.spacing(2)}px 0px`,
        },
        sentText: {
            color: theme.palette.green,
            fontSize: '0.875rem',
            display: 'flex',
            marginLeft: theme.spacing(2),
        },
        sentTextIcon: {
            fontSize: '1.2rem',
        },
        progress: {
            marginLeft: 10,
        },
    };
});

export const AuthForm = ({ values, onChange, onSendCode }) => {
    const [sending, setSending] = useState(false);
    const classes = useStyles();

    const sendCode = async () => {
        setSending(true);
        await onSendCode();
        setSending(false);
    };

    return (
        <>
            <Fields.Phone
                label="Phone number"
                helper="Authentication codes will be sent here"
                onChange={value => onChange({ phone: value })}
                valueFromProps
                value={values.phone}
            />
            <div className={classes.verifyContainer}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={sendCode}
                    disabled={sending || !values.phone}
                >
                    SEND AUTHENTICATION CODE
                    {sending && (
                        <CircularProgress
                            size={12}
                            className={classes.progress}
                        />
                    )}
                </Button>
                {values.code_sended && (
                    <Typography className={classes.sentText}>
                        <DoneIcon className={classes.sentTextIcon} />
                        Sent
                    </Typography>
                )}
            </div>
            <Divider className={classes.divider} />
            <Typography variant="body2">
                Enter the six-digit code sent to your phone
            </Typography>
            <Fields.Text
                disabled={!values.code_sended}
                onChange={value => onChange({ code: value })}
                value={values.code}
                placeholder="123456"
                helper="It may take a minute to arrive."
            />
        </>
    );
};
